/** Базовый класс для создания модальных окон */
export class Modal {
  constructor(options = {}) {
    this.options = {
      className: "",
      closeOnOverlay: true,
      closeOnEscape: true,
      ...options,
    };

    this.modal = null;
    this.closeHandler = null;
  }

  /** Создаёт DOM структуру модального окна
   * @param {string} content - HTML содержимое
   * @returns {HTMLElement}
   */
  createModalStructure(content) {
    const modal = document.createElement("div");
    modal.className = this.options.className;

    modal.innerHTML = `
      <div class="modal-overlay"></div>
      <div class="modal-content">
        ${content}
      </div>
    `;

    return modal;
  }

  /** Навешивает обработчики событий
   * @param {HTMLElement} modal - Элемент модального окна
   * @param {Function} onClose - Колбэк закрытия
   */
  bindEvents(modal, onClose) {
    if (this.options.closeOnOverlay) {
      modal.querySelector(".modal-overlay")?.addEventListener("click", onClose);
    }

    if (this.options.closeOnEscape) {
      const escapeHandler = e => {
        if (e.key === "Escape") {
          onClose();
          document.removeEventListener("keydown", escapeHandler);
        }
      };

      document.addEventListener("keydown", escapeHandler);

      this.escapeHandler = escapeHandler;
    }
  }

  /** Открывает модальное окно и возвращает Promise
   * @param {Object} config - Конфигурация
   * @param {string} config.content - HTML содержимое
   * @param {Function} config.onInit - Колбэк инициализации
   * @returns {Promise<any>}
   */
  open(config) {
    return new Promise(resolve => {
      const modal = this.createModalStructure(config.content);
      document.body.appendChild(modal);
      this.modal = modal;

      const close = result => {
        this.close();
        resolve(result);
      };

      this.bindEvents(modal, () => close(null));

      if (config.onInit) {
        config.onInit({ modal, close });
      }
    });
  }

  /** Закрывает модальное окно и очищает обработчики */
  close() {
    if (this.escapeHandler) {
      document.removeEventListener("keydown", this.escapeHandler);
      this.escapeHandler = null;
    }

    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }
  }
}
